// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CopyId_id__qAzDI {
  display: inline-flex;
  align-items: center;
  color: #acacac;
  font-size: 12px;
  -webkit-user-select: text;
          user-select: text;
  cursor: text;
}

.CopyId_part__zIMvD {
  -webkit-user-select: all;
          user-select: all;
  border-radius: 3px;
}
.CopyId_part__zIMvD:hover {
  background: rgba(59, 127, 212, 0.12);
  color: #838383;
}

.CopyId_sep__sUI4S {
  -webkit-user-select: text;
          user-select: text;
}

.CopyId_btn__RtX2- {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-left: 4px;
  padding: 0;
  font-size: 11px;
  color: #acacac;
  background: none;
  border: 1px solid transparent;
  border-radius: 3px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.CopyId_btn__RtX2-:hover {
  color: #838383;
  border-color: #dbdbdb;
  background: #fff;
}

.CopyId_btnDone__Mtg5Z {
  color: #2d8758;
}

.CopyId_btnFailed__3YAuq {
  color: #a14444;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/CopyId/CopyId.module.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAGA;EACE,oBAAA;EACA,mBAAA;EACA,cCES;EDDT,eAAA;EAEA,yBAAA;UAAA,iBAAA;EACA,YAAA;AAHF;;AAOA;EACE,wBAAA;UAAA,gBAAA;EACA,kBAAA;AAJF;AAME;EACE,oCAAA;EACA,cCXO;ADOX;;AAQA;EACE,yBAAA;UAAA,iBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cC7BS;ED8BT,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AALF;AAOE;EACE,cCpCO;EDqCP,qBCvCO;EDwCP,gBCjCI;AD4BR;;AASA;EACE,cAAA;AANF;;AASA;EACE,cAAA;AANF","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.id {\n  display: inline-flex;\n  align-items: center;\n  color: $grey-300;\n  font-size: 12px;\n  // Rows around it are clickable; the text itself must stay selectable.\n  user-select: text;\n  cursor: text;\n}\n\n// One click selects the whole part (school or licence), ready for Cmd/Ctrl+C.\n.part {\n  user-select: all;\n  border-radius: 3px;\n\n  &:hover {\n    background: rgba(59, 127, 212, 0.12);\n    color: $grey-400;\n  }\n}\n\n.sep {\n  user-select: text;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-left: 4px;\n  padding: 0;\n  font-size: 11px;\n  color: $grey-300;\n  background: none;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  cursor: pointer;\n  user-select: none;\n\n  &:hover {\n    color: $grey-400;\n    border-color: $grey-200;\n    background: $white;\n  }\n}\n\n.btnDone {\n  color: #2d8758;\n}\n\n.btnFailed {\n  color: #a14444;\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"id": `CopyId_id__qAzDI`,
	"part": `CopyId_part__zIMvD`,
	"sep": `CopyId_sep__sUI4S`,
	"btn": `CopyId_btn__RtX2-`,
	"btnDone": `CopyId_btnDone__Mtg5Z`,
	"btnFailed": `CopyId_btnFailed__3YAuq`
};
export default ___CSS_LOADER_EXPORT___;
